module.exports = __webpack_public_path__ + "static/media/basic.7a2c2337.png";